import * as React from 'react';
import { cn } from '@/util/cn';

// Canonical wrapper for the body of resort / region / global content
// pages. Owns the vertical rhythm between top-level sections so each
// page doesn't have to remember whether to use space-y-8 vs space-y-10.
//
// Horizontal edge padding lives one level up in <Layout> (which adds
// max-md:px-4) and the surrounding <Container width="xl-only">; this
// component intentionally doesn't duplicate either, so wrapping in it
// is always safe.

const SPACING = {
  none: '',
  md: 'space-y-8',
  lg: 'space-y-10',
} as const;

export type PageBodySpacing = keyof typeof SPACING;

export interface PageBodyProps {
  children: React.ReactNode;
  /** Vertical rhythm between direct children. Default `lg` (space-y-10). */
  spacing?: PageBodySpacing;
  className?: string;
}

export const PageBody = ({
  children, spacing = 'lg', className,
}: PageBodyProps) => (
  <div className={cn(SPACING[spacing], className)}>
    {children}
  </div>
);
